<template>
  <div class="about-page">
    <div class="about-container">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-state">
        <div class="loading-spinner"></div>
        <p>Loading...</p>
      </div>

      <!-- 关于我们内容 -->
      <div v-else class="about-content">
        <div v-if="aboutContent" v-html="aboutContent" class="rich-text"></div>
        <div v-else class="empty-state">
          <p>No content available</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonApi } from '@/api'

export default {
  name: 'About',
  data() {
    return {
      loading: false,
      aboutContent: ''
    }
  },
  async mounted() {
    await this.loadAboutContent()
  },
  methods: {
    async loadAboutContent() {
      try {
        this.loading = true
        const response = await commonApi.getConfig()
        
        console.log('配置数据响应:', response)
        
        if (response.code === 1 && response.data) {
          this.aboutContent = response.data.yinsi || ''
          console.log('关于我们内容:', this.yinsi)
        } else {
          this.$toast('Load failed', 3000)
        }
      } catch (error) {
        console.error('Failed to load about content:', error)
        this.$toast('Load failed, please try again', 3000)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  /* background: #f5f5f5; */
  padding: 30px 0;
}

.about-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 加载状态 */
.loading-state {
  background: white;
  padding: 80px 40px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #000;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-state p {
  color: #666;
  font-size: 16px;
  margin: 0;
}

/* 关于我们内容 */
.about-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

/* 富文本样式 */
.rich-text {
  color: #333;
  line-height: 1.8;
  font-size: 16px;
}

.rich-text >>> h1 {
  font-size: 32px;
  font-weight: 600;
  margin: 30px 0 20px;
  color: #000;
}

.rich-text >>> h2 {
  font-size: 28px;
  font-weight: 600;
  margin: 25px 0 15px;
  color: #000;
}

.rich-text >>> h3 {
  font-size: 24px;
  font-weight: 600;
  margin: 20px 0 12px;
  color: #000;
}

.rich-text >>> h4 {
  font-size: 20px;
  font-weight: 600;
  margin: 18px 0 10px;
  color: #000;
}

.rich-text >>> p {
  margin: 15px 0;
  line-height: 1.8;
}

.rich-text >>> ul,
.rich-text >>> ol {
  margin: 15px 0;
  padding-left: 30px;
}

.rich-text >>> li {
  margin: 8px 0;
  line-height: 1.6;
}

.rich-text >>> a {
  color: #ffc200;
  text-decoration: none;
  transition: color 0.3s;
}

.rich-text >>> a:hover {
  color: #ffb300;
  text-decoration: underline;
}

.rich-text >>> img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 20px auto;
  border-radius: 4px;
}

.rich-text >>> blockquote {
  border-left: 4px solid #ffc200;
  padding: 10px 20px;
  margin: 20px 0;
  background: #f9f9f9;
  color: #666;
}

.rich-text >>> code {
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 14px;
}

.rich-text >>> pre {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  overflow-x: auto;
  margin: 15px 0;
}

.rich-text >>> pre code {
  background: none;
  padding: 0;
}

.rich-text >>> table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.rich-text >>> table th,
.rich-text >>> table td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

.rich-text >>> table th {
  background: #f5f5f5;
  font-weight: 600;
}

.rich-text >>> hr {
  border: none;
  border-top: 1px solid #e5e5e5;
  margin: 30px 0;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #999;
  font-size: 16px;
}

/* 移动端适配 */
@media (max-width: 767px) {
  .about-page {
    padding: 15px 0 80px;
  }

  .about-container {
    padding: 0 15px;
  }

  .about-content {
    padding: 15px;
  }

  .rich-text {
    font-size: 15px;
  }

  .rich-text >>> h1 {
    font-size: 26px;
  }

  .rich-text >>> h2 {
    font-size: 22px;
  }

  .rich-text >>> h3 {
    font-size: 20px;
  }

  .rich-text >>> h4 {
    font-size: 18px;
  }

  .loading-state {
    padding: 60px 20px;
  }

  .empty-state {
    padding: 60px 20px;
  }
}
</style>
